<template>
  <v-container>
    <v-skeleton-loader
      class="mx-auto"
      max-width="200"
      max-height="600"
      type="text, text"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto my-12"
      max-width="200"
      max-height="600"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto"
      max-width="200"
      max-height="600"
      type="list-item-two-line, list-item-two-line, list-item-two-line"
    ></v-skeleton-loader>
  </v-container>
</template>

<script>
export default {}
</script>

<style scoped></style>
